import { render } from "./UnitChat.vue?vue&type=template&id=f0495fa8&scoped=true"
import script from "./UnitChat.vue?vue&type=script&lang=js"
export * from "./UnitChat.vue?vue&type=script&lang=js"

import "./UnitChat.vue?vue&type=style&index=0&id=f0495fa8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0495fa8"]])

export default __exports__